import { createAsyncThunk } from "@reduxjs/toolkit";
import { durationService } from "../../services";

const getDuration = createAsyncThunk(
    'duration/getDuration',
    async (payload, ThunkAPI) => {
        try{
            const response = await durationService.getDuration();
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

export {
    getDuration,
}